import styled from "styled-components";
import Threshold from "constants/threshold";
import Colors from "constants/colors";

export const EmptyPhoto = styled.div`
  width: 150px;
  height: 150px;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
  margin-bottom: 16px;
  
  @media (min-width: ${Threshold.tablet}) {
    width: 230px;
    height: 230px;
  }
`;

export const ParticipantImageWrapper = styled.div`
  width: 150px;
  height: 150px;
  margin-bottom: 16px;
  
  @media (min-width: ${Threshold.tablet}) {
    width: 230px;
    height: 230px;
  }
`;

export const ParticipantWrapper = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto 25px;
  cursor: pointer;
  text-decoration: none;
  color: ${Colors.black};
  
  & .participant-name {
    font-weight: bold;
    font-size: 14px;
    text-transform: uppercase;
    margin-bottom: 16px;
    text-align: center;
  }
  
  & .participant-city {
    font-size: 12px;
    text-align: center;
  }
  
  @media (min-width: ${Threshold.tablet}) {
    margin: 0 auto 40px;
  }
`;
